<template>
  <UserPhoneColumn :row="member.user" :row-index="rowIndex" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import UserPhoneColumn from '@/components/GraphqlDataTable/columns/User/UserPhoneColumn.vue'

const TeamMemberPhoneColumn = graphql(`
  fragment TeamMemberPhoneColumn on CompanyTeamMember {
    id
    user {
      id
      ...UserPhoneColumn
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof TeamMemberPhoneColumn>
  rowIndex?: number
}>()

const member = computed(() => useFragment(TeamMemberPhoneColumn, props.row))
</script>
